export const UPDATE_NEWSFEED_PROP = 'UPDATE_NEWSFEED_PROP';

// submitting a new post
export const SUBMIT_POST = 'SUBMIT_POST';
export const SUBMIT_POST_FAILED = 'SUBMIT_NEWSFEED_POST_FAILED';
export const POST_SUBMITTED = 'POST_SUBMITTED';

// deleting a post
export const DELETE_POST_STARTED = 'DELETE_POST_STARTED';
export const DELETED_POST = 'DELETED_POST';
export const DELETE_POST_FAILED = 'DELETE_POST_FAILED';

// getting newsfeed
export const GET_NEWSFEED_STARTED = 'GET_NEWSFEED_STARTED';
export const GOT_INITIAL_LOAD_NEWSFEED = 'GOT_INITIAL_LOAD_NEWSFEED';
export const LOADED_MORE_NEWSFEED = 'LOADED_MORE_NEWSFEED';
export const GET_NEWSFEED_FAILED = 'GET_NEWSFEED_FAILED';
export const GET_SINGLE_POST_FAILED = 'GET_SINGLE_POST_FOR_LIST_FAILED';
export const GET_SINGLE_POST_STARTING = 'GET_SINGLE_POST_STARTING';
export const GOT_SINGLE_POST = 'GOT_SINGLE_POST_FOR_LIST';

// getting hashtags
export const GET_HASHTAGS_STARTED = 'GET_HASHTAGS_STARTED';
export const GOT_HASHTAGS = 'GOT_HASHTAGS';
export const GET_HASHTAGS_FAILED = 'GET_HASHTAGS_FAILED';

// reporting a post
export const REPORT_POST_STARTED = 'REPORT_POST_STARTED';
export const REPORTED_POST = 'REPORTED_POST';
export const REPORT_POST_FAILED = 'REPORT_POST_FAILED';

// comments
export const REPORT_COMMENT_STARTED = 'REPORT_COMMENT_STARTED';
export const REPORT_COMMENT_FAILED = 'REPORT_COMMENT_FAILED';
export const REPORTED_COMMENT = 'REPORTED_COMMENT';
export const LOAD_MORE_COMMENTS_STARTED = 'LOAD_MORE_COMMENTS_STARTED';
export const LOAD_MORE_COMMENTS_FAILED = 'LOAD_MORE_COMMENTS_FAILED';
export const LOADED_MORE_COMMENTS = 'LOADED_MORE_COMMENTS';

// updating a post
export const START_UPDATING_A_POST = 'START_UPDATING_A_POST_NEWSFEED';
export const UPDATED_POST = 'UPDATED_POST';
export const UPDATE_POST_FAILED = 'UPDATE_POST_FAILED';



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/constants.js